








































































import { Component } from "vue-property-decorator";
import PageLisUIMixin from '@/common/mixin/PageLisUIMixin';
import {Api} from '@/api/Api';
import IvtEditUI from './IvtEditUI.vue';

@Component
export default class IvtListUI extends PageLisUIMixin {
    public mounted() {
        this.searchParam.conds = {
        }
        this.loadData();
    } 

    // 响应点击查询
    private doQuery() {
        this.loadData();
    }

    private loadData() {
        this.pageRequest(() => {
            Api.prize.getIvtPageList(this.searchParam).then( (data: any) => {
                this.pageReload(data);
            });
        });
    }

    private doAddClick() {
        const dlgInstance = this.ets.dialog.openDialog({
            title: '新增Ivt',
            icon: '',
            page: IvtEditUI,
            param: {
                type: 'ADD',
            },
            width: '600px',
            height: '300px',
        });
        dlgInstance.closeCallbak( (resp: any) => {
            if (resp.code === 'OK') {
                this.doQuery();
            }
        });
    }
}
